import { useState, cloneElement, useCallback } from 'react';
import { Menu as MuiMenu } from '@mui/material';
import MenuItem from '../MenuItem';

export default function Menu({
  anchorElement = null,
  children = null,
  isOpen = false,
  onClose = () => {},
  onOpen = () => {},
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const clickAnchorElementHandler = useCallback(
    (e) => {
      if (isOpen) {
        onClose();
        setAnchorEl(null);
      } else {
        onOpen();
        setAnchorEl(e.currentTarget);
      }
    },
    [isOpen, onClose, onOpen]
  );

  return (
    <>
      {anchorElement && cloneElement(anchorElement, { onClick: clickAnchorElementHandler })}
      <MuiMenu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        MenuListProps={{ component: 'nav' }}
        open={isOpen}
        onClose={onClose}
      >
        {children}
      </MuiMenu>
    </>
  );
}

Menu.Item = MenuItem;
